import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../abstract.bidit.component';
import { QuoteAcknowledgement } from '../../models/quote.acknowledgement.interface';
import { QuoteBase } from '../../models/quote.base.interface';
import { Quote } from '../../models/quote.interface';
import { FileService } from '../../services/file.service';
import { QuoteService } from '../../../quote/services/quote.service';


@Component({
  selector: 'app-acknowledgement-list',
  templateUrl: './acknowledgement-list.component.html',
  styleUrls: ['./acknowledgement-list.component.scss']
})
export class AcknowledgementListComponent extends AbstractBiditComponent {
  errors: string;
  isRequesting: boolean;

  quote: Quote;

  constructor(private dialog: MatDialog, deviceDetectorService: DeviceDetectorService, private fileService: FileService, private quoteService: QuoteService) {
    super(deviceDetectorService);
  }

  @Input()
  public set project(value: Quote) {
    if (value) {
      this.quote = value;
    }
  }

  get quoteAcknowledgements(): QuoteAcknowledgement[] {
    if (this.quote == undefined) return [];
    let qa = this.quote.quoteAcknowledgements.sort((a, b) => b.quoteAcknowledgement_ID - a.quoteAcknowledgement_ID);

    if (this.quote.quote_Converted != undefined) {
      //      qa = qa.filter(ack => ack.changeOrder_ID != undefined);
    }

    return qa;
  }

  changeOrderLabel(changeOrder_ID: number): string {
    const changeOrder = this.quote.changeOrders.find(co => co.changeOrder_ID == changeOrder_ID);
    if (changeOrder_ID === undefined || changeOrder_ID === null) {
      return '- Quote'
    }
    else {
      return ` - ${changeOrder?.changeOrder_Name}`;
    }
  }

  downloadAttachment(acknowledgement: QuoteAcknowledgement) {
    this.quoteService.getQuoteAcknowlegementAttachment(acknowledgement.quoteAcknowledgement_ID)
      .subscribe(x => {
        if (x !== null) {
          let fileName = `QuoteContract_${acknowledgement.quote_ID}.pdf`;
          this.fileService.downloadFile(x, fileName);
        }
      });
  }
}
